import React from 'react'
import _ from 'lodash'
import Loading from './Loading'

const withLoading = WrappedComponent => {
  return class LoadingHandler extends React.Component {
    state = {
      isLoading: false,
    }

    handleLoading = isLoading => {
      this.setState({ isLoading })
    }

    render() {
      const loading = _.get(this.props, 'data.loading') || this.state.isLoading
      return (
        <React.Fragment>
          {loading && <Loading />}
          <WrappedComponent {...this.props} onLoading={this.handleLoading} />
        </React.Fragment>
      )
    }
  }
}

export default withLoading



// WEBPACK FOOTER //
// ./src/modules/loader/withLoading.js